module.exports = __webpack_public_path__ + "static/media/logo-facebook.46c0bd59.svg";